export const SubscriptionStatusColor = {
  CONTRACT: "blue",
  SETUP: "cyan",
  INSPECTION: "purple",
  ACTIVE: "green",
  SUSPENDED: "orange",
  TERMINATED: "red",
};

export const SubscriptionStatusText = {
  CONTRACT: "계약",
  SETUP: "세팅",
  INSPECTION: "검수",
  ACTIVE: "활성",
  SUSPENDED: "중단",
  TERMINATED: "종료",
};

export const PaymentStatusColor = {
  PENDING: "blue",
  COMPLETED: "green",
  FAILED: "red",
  REFUNDED: "orange",
  PARTIAL_REFUNDED: "gold",
  CANCELED: "default",
};

export const PaymentStatusText = {
  PENDING: "대기중",
  COMPLETED: "완료",
  FAILED: "실패",
  REFUNDED: "환불",
  PARTIAL_REFUNDED: "부분환불",
  CANCELED: "취소",
};

export const PaymentCycleColor = {
  MONTHLY: "green",
  YEARLY: "purple",
  ONCE: "cyan",
};

export const PaymentCycleText = {
  MONTHLY: "월간",
  YEARLY: "연간",
  ONCE: "1회성",
};

export const getSubscriptionStatusColor = (status) =>
  SubscriptionStatusColor[status] || "default";
export const getSubscriptionStatusText = (status) =>
  SubscriptionStatusText[status] || status;
export const getPaymentStatusColor = (status) =>
  PaymentStatusColor[status] || "default";
export const getPaymentStatusText = (status) =>
  PaymentStatusText[status] || status;
export const getPaymentCycleColor = (cycle) =>
  PaymentCycleColor[cycle] || "default";
export const getPaymentCycleText = (cycle) => PaymentCycleText[cycle] || cycle;
